import { RouterView } from "vue-router";

export const schoolsRoute = {
  path: ":menu/schools",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/schools/list/index.vue"),
    },
  ],
};
